var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.order,
          expression: "order"
        }
      ],
      staticClass: "modal fade",
      attrs: {
        id: "deleteModal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "ModalLabel"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { attrs: { id: "oc-backend-delete-order" } }, [
            _vm._m(0),
            _vm._v(" "),
            _vm.order
              ? _c("div", { attrs: { id: "request_number" } }, [
                  _vm._v(_vm._s(_vm.order.id))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { type: "button" },
                  on: { click: _vm.deleteOrder }
                },
                [_vm._v("Удалить")]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-link",
                  attrs: { type: "button", "data-dismiss": "modal" }
                },
                [_vm._v("Отменить")]
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _vm._v("\n          Вы действительно"),
      _c("br"),
      _vm._v("хотите удалить зявку?\n        ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e563e644", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e563e644","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/backend/components/dialogs/DeleteModal.vue
// module id = 201
// module chunks = 1